// src/index.js

import React, { useState} from "react";
import ReactDOM from "react-dom/client";

// Use BrowserRouter so URLs are like /about or /books/dragon.html
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation
} from "react-router-dom";

import "./CSS_stuff/global.css";
import NavMenu from "./Components/Nav_menu";
import FeaturedBooks from "./Components/Featured_books";
import Footnote from "./Components/Footnote";
import Special_stuff_homepage from "./Components/Special_stuff_homepage.js"

// Page components
import Contact from "./Pages/contact_info";
import Fiction from "./Pages/fiction";
import FullCatalog from "./Pages/FullCatalog";
import Newsletter from "./Pages/Newsletter";
import BookPage from "./Components/BookPage";
import About from "./Pages/about";
import Lore from "./Pages/Lore2.js";
import PrivacyPolicy from "./Pages/Privacy-policy";
import UpcomingBooks from "./Pages/UpcomingBook.js";
import UpcomingEvents from "./Pages/Upcomingevents.js";
import MiniSeriesPage from "./Pages/Mini-Series";

import facebookLogo from "./assets/Facebook_Logo_Primary.png";

function MainContent() {
  const location = useLocation();

  return (
    <div className="main-content">
      {location.pathname === "/" && <Special_stuff_homepage />}

      <Routes>
        {/* Privacy Policy */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />

        {/* About */}
        <Route path="/about" element={<About />} />
        <Route path="/about.html" element={<About />} />

        {/* Contact */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/contact.html" element={<Contact />} />

        {/* Newsletter */}
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/newsletter.html" element={<Newsletter />} />

        {/* Fiction hub */}
        <Route path="/fiction" element={<Fiction />} />
        <Route path="/fiction.html" element={<Fiction />} />

        {/* Mini-series (single mini-series view) */}
        <Route path="/mini-series/:series" element={<MiniSeriesPage />} />
        <Route path="/mini-series/:series.html" element={<MiniSeriesPage />} />

        {/* Single book: both /books/:id and /books/:id.html */}
        <Route path="/books/:id" element={<BookPage />} />
        <Route path="/books/:id.html" element={<BookPage />} />

        {/* Full catalog */}
        <Route path="/catalog" element={<FullCatalog />} />
        <Route path="/catalog.html" element={<FullCatalog />} />

        {/* Upcoming books */}
        <Route
          path="/upcoming-books"
          element={<UpcomingBooks/>}
        />
        <Route
          path="/upcoming-books.html"
          element={<UpcomingBooks/>}
        />

        {/*Route for Upcoming events*/}
        <Route path="/upcoming-events" element={<UpcomingEvents />} />
        <Route path="/upcoming-events.html" element={<UpcomingEvents />} />


        {/* Lore */}
        <Route path="/lore" element={<Lore />} />
        <Route path="/lore.html" element={<Lore />} />
      </Routes>
    </div>
  );
}

function App() {
  const [showBanner, setShowBanner] = useState(true);

  return (
    <Router>
      {showBanner && (
        <div className="newsletter-banner">
          <Link to="/newsletter" className="newsletter-link">
            Join my newsletter and get THREE exclusive stories!!!
          </Link>
          <a
            href="https://www.facebook.com/RisingDragonBooks"
            className="banner-facebook-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit us on Facebook"
          >
            <img
              src={facebookLogo}
              alt="Facebook"
              className="banner-facebook-icon"
            />
          </a>
          <button
            className="newsletter-close"
            onClick={() => setShowBanner(false)}
            aria-label="Dismiss banner"
          >
            ×
          </button>
        </div>
      )}
      <div className="index-container">
        <NavMenu />
        <div className="page-content">
          <MainContent />
        </div>
        <Footnote />
      </div>
    </Router>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);